var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@tanstack/react-query';
import { makeManagePartnersSimple } from '@/main/factories/usecases/manage-partners/manage-partners';
import { useParams } from 'react-router';
import { useEffect } from 'react';
const service = makeManagePartnersSimple();
const chacheTime = 0;
const usePartner = ({ userId, idPartnerPreview }) => {
    var _a, _b, _c;
    const { partnerPath } = useParams();
    console.log('partnerPath:', partnerPath);
    const { data, refetch } = useQuery({
        queryKey: ['logoInfo', `userId=${userId}`, `idPartnerPreview=${idPartnerPreview}`],
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            return yield service.logoInfo({
                partnerPath,
                userId,
                idPartnerPreview
            });
        }),
        gcTime: chacheTime,
        retry: false,
        staleTime: chacheTime
    });
    const rootPath = partnerPath ? `/partner/${partnerPath}/` : '/';
    const urlLogo = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.urlLogo;
    const partner = (_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.partner;
    const saveInStorage = !!((_c = data === null || data === void 0 ? void 0 : data.data) === null || _c === void 0 ? void 0 : _c.saveInStorage);
    useEffect(() => {
        if (partnerPath && (partner === null || partner === void 0 ? void 0 : partner.uniquePathPU)) {
            if (partnerPath !== (partner === null || partner === void 0 ? void 0 : partner.uniquePathPU)) {
                console.error('Partner path is not valid');
                localStorage.removeItem('partnerId');
                refetch();
            }
        }
    }, [partnerPath, partner === null || partner === void 0 ? void 0 : partner.uniquePathPU]);
    useEffect(() => {
        if ((partner === null || partner === void 0 ? void 0 : partner.id) && partnerPath && saveInStorage) {
            localStorage.setItem('partnerId', partner === null || partner === void 0 ? void 0 : partner.id);
        }
    }, [partner === null || partner === void 0 ? void 0 : partner.id, partnerPath, saveInStorage]);
    return { urlLogo, partner, partnerPath, rootPath };
};
export default usePartner;
